import { render, staticRenderFns } from "./HelpDeskWidget.vue?vue&type=template&id=8cf22728&scoped=true"
import script from "./HelpDeskWidget.vue?vue&type=script&lang=js"
export * from "./HelpDeskWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf22728",
  null
  
)

export default component.exports